module.exports = __webpack_public_path__ + "assets/56f3de04.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/movie-orange.png
// module id = 93
// module chunks = 0